import React, { useEffect } from "react";
import { Row, Col, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Title from "../../components/Title/Title";
import "./AboutMobileApps.scss";

export default function AboutMobileApps() {
  useEffect(() => {
    AOS.init();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="apps_about" className="section section-bg py-5">
      <div className="container subpage-container">
        <Row data-aos="fade-down" data-aos-duration="500">
          <Col xs={12} className="text-center">
            <Title
              regular_text="Unlock Your Potential with Our"
              highlighted_text="Mobile App Expertise"
            />
            <div className="ratio ratio-16x9 my-4 video-wrapper shadow-sm">
              <iframe
                src="https://www.youtube.com/embed/raj86mSQQGk"
                title="Mobile App Development Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Col>
        </Row>

        <Row data-aos="fade-up" data-aos-duration="500" className="my-4">
          <Col xs={12}>
            <p className="lead-text">
              Whether you're ready to create a mobile app for your business or
              seeking to revitalize your existing one, we're here to make it happen.
              Drawing from our extensive industry experience, we've streamlined the
              app-building process, ensuring your vision becomes a reality. With our
              guidance, you'll gain a deeper understanding of what your mobile app
              should embody, while maintaining complete control throughout the
              development journey.
            </p>
            <p className="lead-text">
              Embark on your app-building journey with a complimentary consultation
              tailored to your unique business needs and style. We'll recommend a
              customized plan and provide you with an initial estimate of the
              project's overall cost.
            </p>
            <div className="text-center my-4">
              <Button as={Link} to="/home/contact" size="lg" variant="primary" className="btn-main">
                Contact Us
              </Button>
            </div>
          </Col>
        </Row>

        {/* Approach Section */}
        <div className="approach-section my-5">
          <Row data-aos="fade-up" data-aos-duration="500">
            <Col xs={12} className="text-center mb-5">
              <Title regular_text="Our" highlighted_text="Approach" />
            </Col>
          </Row>

          {/* Step 1 */}
          <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
            <Col xs={12} md={6} className="order-2 order-md-1 text-md-end">
              <div className="step-content">
                <h3>1. Wireframes & Planning</h3>
                <p>
                  Wireframes serve as the architectural foundation of your mobile app.
                  Our meticulous attention to detail will bring your app one step
                  closer to fruition, providing you with detailed visual representations
                  and behavior blueprints. This collaborative step allows us to explore
                  and discuss the feasibility of different concepts. By the end, you'll
                  have a clear understanding of the app's structure, development timeline,
                  and precise cost.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} className="order-1 order-md-2 text-center text-md-start mb-3 mb-md-0">
              <Image
                src={require("../../assets/blog/blog-post-2-02.jpg")}
                className="step-image rounded-circle shadow-sm"
                alt="Wireframes & Planning"
              />
            </Col>
          </Row>

          {/* Step 2 */}
          <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
            <Col xs={12} md={6} className="text-center text-md-end mb-3 mb-md-0">
              <Image
                src={require("../../assets/blog/blog-post-2-03.png")}
                className="step-image rounded-circle shadow-sm"
                alt="Development"
              />
            </Col>
            <Col xs={12} md={6} className="text-md-start">
              <div className="step-content">
                <h3>2. Development</h3>
                <p>
                  The development phase is where the magic happens. We'll craft your
                  application for both Apple (iOS) and Android platforms, tailored to
                  your specific requirements. This phase is divided into two-week intervals,
                  with regular updates delivered to your device for hands-on personal
                  testing and feedback.
                </p>
                <p>
                  Throughout the process, we'll engage with you twice a week to capture
                  and incorporate your invaluable input and suggestions. This ensures
                  that you retain full control over every aspect of the app's development.
                </p>
              </div>
            </Col>
          </Row>

          {/* Step 3 */}
          <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
            <Col xs={12} md={6} className="order-2 order-md-1 text-md-end">
              <div className="step-content">
                <h3>3. Testing & Polishing</h3>
                <p>
                  Once all modifications are complete, we'll meticulously review the app,
                  addressing any final touches or minor adjustments required. Our goal
                  is to ensure that every detail aligns perfectly with your expectations,
                  leaving you completely satisfied with the outcome.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} className="order-1 order-md-2 text-center text-md-start mb-3 mb-md-0">
              <Image
                src={require("../../assets/blog/blog-post-1-04.png")}
                className="step-image rounded-circle shadow-sm"
                alt="Testing & Polishing"
              />
            </Col>
          </Row>

          {/* Step 4 */}
          <Row className="align-items-center mb-5 step-row" data-aos="fade-up" data-aos-duration="500">
            <Col xs={12} md={6} className="text-center text-md-end mb-3 mb-md-0">
              <Image
                src={require("../../assets/blog/blog-post-2-04.png")}
                className="step-image rounded-circle shadow-sm"
                alt="Publishing"
              />
            </Col>
            <Col xs={12} md={6} className="text-md-start">
              <div className="step-content">
                <h3>4. Publishing</h3>
                <p>
                  The final step involves navigating the intricate process of publishing
                  your app to the Google Play Store and the Apple App Store. Don't worry
                  - we'll be there to guide you. Soon after, your app will be available
                  for download by your eager users, cementing your presence in the digital market.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Costs Section */}
        <div className="costs-section my-5" data-aos="fade-up" data-aos-duration="500">
          <Row>
            <Col xs={12} className="text-center mb-4">
              <Title regular_text="About" highlighted_text="Costs" />
            </Col>
            <Col xs={12}>
              <p className="lead-text">
                The cost of your app will vary depending on your specific requirements.
                A helpful analogy is building a house: you can choose to construct a
                small shed or a grand mansion with multiple bedrooms and luxurious finishes.
                That is why we begin with the wireframing and development planning phase,
                which allows us to provide you with a precise cost estimate.
              </p>
              <p className="lead-text">
                We are highly confident in our competitive pricing. After we have
                completed the wireframes and determined the total cost, we encourage you,
                if you wish, to conduct research and obtain multiple quotes.
                This way, you can be assured that you are receiving the best deal
                available on the market.
              </p>
              <p className="lead-text">
                We hope that learning about our meticulous mobile app development
                process has provided you with greater comfort and brings us one step
                closer to partnering with you to bring your amazing mobile app idea to life.
                Please feel free to contact us without hesitation.
              </p>
              <div className="text-center my-4">
                <Button as={Link} to="/home/contact" size="lg" variant="primary" className="btn-main">
                  Contact Us
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
